module.exports = __webpack_public_path__ + "img/mypc.f2a5e4a3.png";